export default __webpack_public_path__ + "static/media/why4.9dcf095f.svg";